import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined'
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt'
import Tooltip from '@mui/material/Tooltip'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import BugReport from '@mui/icons-material/BugReport'
import API from '../../services/API'
import { useContext, useEffect, useState } from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import { UserContext } from '../../App'

const RoadmapCard = ({ task }) => {
  const priority = task?.priority?.priority?.toUpperCase() ?? 'NORMAL'

  const { user } = useContext(UserContext)

  const [voted, setVoted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [voteCount, setVoteCount] = useState(Number(task.voteCount) ?? 0)
  const [existingVoters, setExistingVoters] = useState(task.voters ?? [])

  useEffect(() => {
    if (task?.voters?.includes(user._id)) {
      setVoted(true)
    }
  }, [task])

  const handleVote = () => {
    setLoading(true)
    API.post('/dev/voteroadmap', {
      taskID: task.id,
      existingVoters,
      newVoteCount: voteCount + 1,
    }).then((res) => {
      if (res.status === 200) {
        setVoted(true)
        setVoteCount((prev) => prev + 1)
        setExistingVoters((prev) => [...prev, user._id])
        setLoading(false)
      }
    })
  }

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 3,
        p: 2,
        boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
        borderLeft: `4px solid ${
          ['triaged', 'new'].includes(task.status)
            ? '#444'
            : task.status === 'Closed'
              ? '#076200'
              : '#4A63FF'
        }`,
        transition: '0.2s ease',
        cursor: 'default',
        '&:hover': {
          boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      <Stack spacing={0.75}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="flex-start"
          justifyContent="space-between"
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="flex-start"
            sx={{ minWidth: 0 }}
          >
            {task.type === 'Bug' && (
              <BugReport
                fontSize="small"
                sx={{
                  color: task.status === 'Backlog' ? '#444' : '#4A63FF',
                  opacity: 0.9,
                  flexShrink: 0,
                }}
              />
            )}

            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '0.95rem',
                lineHeight: 1.25,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {task.name}
            </Typography>
          </Stack>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ flexShrink: 0 }}
          >
            {/* Vote chip */}
            {task.status !== 'Closed' && (
              <Tooltip title={voted ? 'You voted for this' : 'Votes'} arrow>
                <Chip
                  size="small"
                  icon={
                    voted ? (
                      <ThumbUpAltIcon fontSize="small" color="anGreen" />
                    ) : (
                      <ThumbUpAltOutlinedIcon fontSize="small" color="anBlue" />
                    )
                  }
                  label={
                    loading ? (
                      <Box sx={{ width: 24 }}>
                        <LinearProgress />
                      </Box>
                    ) : (
                      voteCount
                    )
                  }
                  variant={voted ? 'filled' : 'outlined'}
                  sx={{
                    borderRadius: 1,
                    fontWeight: 600,
                    ...(voted
                      ? {
                          bgcolor: 'anGreen.main',
                          color: 'anGreen.contrastText',
                          '& .MuiChip-icon': { color: 'anGreen.contrastText' },
                        }
                      : {}),
                  }}
                  onClick={() => !voted && handleVote()}
                />
              </Tooltip>
            )}

            {['URGENT', 'HIGH'].includes(priority) && (
              <Chip
                size="small"
                color={priority === 'URGENT' ? 'anRed' : 'anBlue'}
                label={priority}
                sx={{ borderRadius: 1 }}
                variant="filled"
              />
            )}
          </Stack>
        </Stack>

        <Typography
          variant="body2"
          sx={{ opacity: 0.7, fontSize: '0.8rem', lineHeight: 1.4 }}
        >
          {task.description}
        </Typography>
      </Stack>
    </Box>
  )
}

export default RoadmapCard
